module.exports = __webpack_public_path__ + "static/media/multicultural.abf70f4a.mp4";